module.exports = __webpack_public_path__ + "media/images/slide-9-d3932db720f56396a8e3d87afb8684cd.jpg";